import * as React from 'react';
import { useStore } from 'zustand';
import { dataSourceStore } from './data-source.store';
import type { DataSourceStore } from './data-source.store';

const DataSourceStoreContext = React.createContext<
  typeof dataSourceStore | null
>(null);

export const DataSourceStoreProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const store = React.useRef(dataSourceStore);

  return (
    <DataSourceStoreContext.Provider value={store.current}>
      {children}
    </DataSourceStoreContext.Provider>
  );
};

export function useDataSourceStore() {
  const store = React.useContext(DataSourceStoreContext);
  if (!store) {
    throw new Error(
      'No provider found. useDataSourceStore must be called within a child of a DataSourceStoreProvider',
    );
  }
  return store;
}

export function useDataSourceStoreSelector<T>(
  selector: (state: DataSourceStore) => T,
): T {
  const store = React.useContext(DataSourceStoreContext);
  if (!store) {
    throw new Error(
      'No provider found. useDataSourceStore must be called within a child of a DataSourceStoreProvider',
    );
  }

  return useStore(store, selector);
}
